import React from 'react';

const CustomerPortalSection = () => {
  // Features list for the portal
  const portalFeatures = [
    {
      id: 1,
      text: 'Centralized infrastructure management',
      icon: (
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
        />
      )
    },
    {
      id: 2,
      text: 'Detailed activity and audit logs',
      icon: (
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" 
        />
      )
    },
    {
      id: 3,
      text: 'Resource monitoring and performance insights',
      icon: (
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
        />
      )
    },
    {
      id: 4,
      text: 'Fast access to expert technical support',
      icon: (
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" 
        />
      )
    }
  ];

  // Arrow Icon for button
  const ArrowIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
    </svg>
  );

  // Check Icon for list items
  const CheckIcon = ({ path }) => (
    <svg className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      {path}
    </svg>
  );

  return (
    <section className="py-10 md:py-32 bg-gradient-to-br from-gray-900 via-gray-800 to-[#1a1a2e] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-r from-[#E75301]/20 to-purple-600/20"></div>
      </div>
      <div className="absolute top-20 left-10 w-32 h-32 bg-[#E75301]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-48 h-48 bg-purple-600/20 rounded-full blur-3xl"></div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Side - Text Content */}
          <div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Manage Your Infrastructure with Ease
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Access everything you need from a single dashboard – monitor resources, track activity, and manage your services efficiently.
            </p>
            
            {/* Features List */}
            <div className="mb-8">
              <ul className="space-y-3">
                {portalFeatures.map((feature) => (
                  <li key={feature.id} className="flex items-start gap-3">
                    <CheckIcon path={feature.icon} />
                    <span className="text-gray-300">{feature.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* CTA Button */}
            <a 
              href="/migration/portal" 
              className="inline-flex items-center gap-2 px-8 py-4  bg-gradient-to-r from-blue-600 to-green-500 text-white text-white font-semibold rounded-xl hover:bg-[#ad3a00] transform hover:scale-105 transition-all duration-300 shadow-xl shadow-green-500/30"
            >
              Explore Portal
              <ArrowIcon />
            </a>
          </div>
          
          {/* Right Side - Dashboard Image */}
          <div className="relative">
            {/* Glow Effect Behind Image */}
            <div className="absolute -inset-8 bg-gradient-to-br from-[#E75301]/30 to-purple-600/20 rounded-3xl blur-3xl"></div>
            
            {/* Dashboard Image */}
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-white/5 backdrop-blur">
              <img 
                src="../assets/images/migration/wz-portal-dashboard-dc863234c53b57e6e3fcf1ec714027d9.png" 
                alt="Ayanshtech SolutionsCustomer Portal Dashboard" 
                className="w-full h-auto" 
                loading="lazy"
              />
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default CustomerPortalSection;